import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
    List,
    ListItem,
    ListItemText,
    Typography,
    IconButton,
    Grid,
    Modal,
    Alert,
    CircularProgress,
} from "@mui/material/";
import PublishOutlinedIcon from "@mui/icons-material/PublishOutlined";
import makeStyles from "@mui/styles/makeStyles";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./styles";
import { format } from "../../common/lib";
import actions from "../../Store/actions";
import useOutdatedAudits from "./useOutdatedAudits";
import { logToSentry } from "../../config/Sentry";
import { useToaster } from "../../common/hooks";
/**
 * Outdated Audits List  Component
 */
export default () => {
    const { auth } = useSelector((state) => state);
    const dispatch = useDispatch();
    const { firstName } = auth.account;
    const classes = makeStyles(styles)();
    const toast = useToaster();
    const { t } = useTranslation();
    const [open, setOpen] = useState(true);
    const [auditName, setAuditName] = useState("");
    const outdatedAudits = useOutdatedAudits();

    useEffect(() => {
        //Clear if the audit is set.(This can happen due to saveState )
        dispatch(actions.audits.create.itemClear());
    }, []);

    const onSubmitAudit = async (item) => {
        try {
            setAuditName(item.name);
            await dispatch(actions.audits.create.itemSet(item));
            await dispatch(actions.auditUpload.create.postRequest());
            setAuditName("");
        } catch (error) {
            console.log(error);
            toast.error(t("errors.uploadOutdatedAudit", { auditName }));
            logToSentry("Outdated Audits  onSubmitAudit", {
                error,
                errStr: error.toString(),
            });
            setAuditName("");
        }
    };
    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") return;
        setOpen(false);
    };

    /** When submitting disable all actions */
    const disableAction = auditName.length > 0 ? true : false;

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="message-modal"
            aria-describedby="audit-close-modal"
        >
            <Grid container className={classes.modalBox}>
                <Grid item xs={8}>
                    <Typography
                        id="modal-description"
                        className={classes.modalMessage}
                        variant="h6"
                        gutterBottom
                    >
                        {t("outdatedAudits")}
                    </Typography>
                </Grid>
                <Grid item xs={4} className={classes.closeButton}>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        disabled={disableAction}
                    >
                        <CloseIcon color="primary" />
                    </IconButton>
                </Grid>
                <Grid item xs={12}>
                    <Alert severity="warning">
                        {t("messages.outdatedAudits", {
                            firstName,
                        })}{" "}
                    </Alert>

                    {disableAction && (
                        <Alert severity="info">
                            {t("messages.auditSubmissionMessage", {
                                auditName,
                            })}{" "}
                            <CircularProgress color="inherit" size={20} />
                        </Alert>
                    )}
                </Grid>

                <List className={classes.listContainer}>
                    {outdatedAudits.map((item) => {
                        return (
                            <ListItem
                                key={`${item.name}-${item.startDate}-${item.id}`}
                                secondaryAction={
                                    <IconButton
                                        title="submit"
                                        onClick={(evt) => {
                                            onSubmitAudit(item);
                                        }}
                                        disabled={disableAction}
                                    >
                                        {!disableAction > 0 && (
                                            <PublishOutlinedIcon color="primary" />
                                        )}
                                    </IconButton>
                                }
                            >
                                <ListItemText
                                    primary={
                                        <Typography variant="subtitle2">
                                            {item.name}
                                        </Typography>
                                    }
                                    secondary={
                                        <Typography variant="caption">
                                            {format.dateTime(item.endDate)}
                                        </Typography>
                                    }
                                />
                            </ListItem>
                        );
                    })}
                </List>
            </Grid>
        </Modal>
    );
};
